<ion-footer class="ion-padding">
    <ng-content></ng-content>
</ion-footer>
